/**
 * PanTool — Canvas panning
 * Per PLAN.md interactions/PanTool.js
 */

import { eventBus, Events } from '../core/EventBus.js';

export class PanTool {
    /**
     * @param {import('../core/Canvas.js').Canvas} canvas 
     */
    constructor(canvas) {
        this.canvas = canvas;
        this.isActive = false;
        this.isPanning = false;
        this.lastX = 0;
        this.lastY = 0;
    }

    /**
     * Start panning
     * @param {number} screenX 
     * @param {number} screenY 
     */
    start(screenX, screenY) {
        this.isPanning = true;
        this.lastX = screenX;
        this.lastY = screenY;
        this.canvas.container.style.cursor = 'grabbing';
    }

    /**
     * Continue panning
     * @param {number} screenX 
     * @param {number} screenY 
     */
    move(screenX, screenY) {
        if (!this.isPanning) return;

        const dx = screenX - this.lastX;
        const dy = screenY - this.lastY;

        this.lastX = screenX;
        this.lastY = screenY;

        this.canvas.viewport.pan(dx, dy);
    }

    /**
     * End panning
     */
    end() {
        this.isPanning = false;
        this.canvas.container.style.cursor = this.isActive ? 'grab' : '';
    }

    /**
     * Activate/deactivate this tool
     * @param {boolean} active 
     */
    setActive(active) {
        this.isActive = active;
        this.canvas.container.style.cursor = active ? 'grab' : '';

        if (!active) {
            this.end();
        }
    }
}
